import React, { useContext } from 'react';
import ReactSVG from 'react-svg';
import { decode } from 'html-decoder';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import times from 'times.svg';
import { CommunitiesContext } from '../../context/CommunitiesContext';
import sortByName from '../../utils/sortByName';

export default function CommunitiesModal() {
  const {
    communities,
    getMoreCommunities,
    showMore,
    city,
    loading,
  } = useContext(CommunitiesContext);

  const handleClose = () => {
    document.querySelector('#communities-modal').classList.add('hidden');
    clearAllBodyScrollLocks();
    document.querySelector('body').style.overflow = '';
  };

  if (communities)
    return (
      <div className="modal community">
        <button
          className="close-modal"
          id="communities-close"
          name="Close Communities Modal"
          aria-label="Close Communities Modal"
          type="button"
          onClick={handleClose}
        >
          <ReactSVG src={times} />
        </button>

        <div className="communities-wrapper">
          <h3 className="modal-title">Communities</h3>
          <main className="communities-list">
            {[...communities].sort(sortByName).map(community => {
              const splitUrl = community.url.split('/');
              const slug = splitUrl[splitUrl.length - 2];

              return (
                <p key={community.id}>
                  <a
                    aria-label={community.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    // Manually build out route for community show path.
                    href={`/${city}/vacation-rentals/${slug}`}
                  >
                    {decode(community.name)}
                  </a>
                </p>
              );
            })}
          </main>
          {showMore && (
            <button
              type="button"
              aria-label="Get More Communities"
              title="Get More Communities"
              name="Get More Communities"
              className={`load-more-communities ${loading ? 'loading' : ''}`}
              disabled={loading}
              onClick={getMoreCommunities}
            >
              Show More
            </button>
          )}
        </div>
      </div>
    );
  return null;
}
